import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RequestFormService } from '../home/services/request-form.service';

@Component({
  selector: 'app-solicitud-company-loan',
  templateUrl: './solicitud-company-loan.component.html',
  styleUrls: ['./solicitud-company-loan.component.scss'],
})
export class SolicitudCompanyLoanComponent {
  inputText = '';
  charCount = 0;
  nombre_solicitante: string = "";
  motivo_solicitud: string = "";
  monto_solicitud: string = "";
  compromiso_pago_solicitud: string = "";
  origen: string = "";
  summary_data: any;
  emptyFieldForm=false

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private requestFormService: RequestFormService,) {   
    this.summary_data = data["summary_data"];
    this.nombre_solicitante = `${this.summary_data["informacion_personal"]["Nombres"]["valor"] ?? ''} ${this.summary_data["informacion_personal"]["Apellidos"]["valor"] ?? ''}`
    this.motivo_solicitud = `${this.summary_data["informacion_adicional"]["Motivo_de_la_solicitud"]["valor"] ?? ''}`
    this.monto_solicitud = `${this.summary_data["informacion_adicional"]["Monto"]["valor"] ?? ''}`
    this.compromiso_pago_solicitud = `${this.summary_data["informacion_adicional"]["Compromiso_de_pago"]["valor"] ?? ''}`
    this.origen = data["origen"] ?? "";

  }
  
  updateCharCount() {
    this.charCount = this.inputText.length;
  }

  aprobar() {
    if(this.inputText.length > 0){
    const sd_aprobacion_bp = this.summary_data;
    switch(this.origen) {
      case "bp":
        sd_aprobacion_bp["informacion_aprobacion"]["resolucionBP"] = true;
        sd_aprobacion_bp["informacion_aprobacion"]["antecedentesBP"] = this.inputText;
        sd_aprobacion_bp.mensaje_historial="Líder CVB ha validado la solicitud";
        break;
      case "jefe_bp":
          sd_aprobacion_bp["informacion_aprobacion"]["resolucionJefBP"] = true;
          sd_aprobacion_bp["informacion_aprobacion"]["antecedentesJefBP"] = this.inputText;
          sd_aprobacion_bp.mensaje_historial="BP ha validado la solicitud";
          break;
      case "gerente_personas":
        sd_aprobacion_bp["informacion_aprobacion"]["resolucionGerPer"] = true;
        sd_aprobacion_bp["informacion_aprobacion"]["antecedentesGerPer"] = this.inputText;
        sd_aprobacion_bp.mensaje_historial="Gerente de Personas ha validado la solicitud";
        break;
    }
    
    this.requestFormService.putApplicationStatusUpdate(
      sd_aprobacion_bp,
      1,
      this.data["id_solicitud"],
      this.data["id_beneficio"]

    );
  }else{
    this.emptyFieldForm = true;
  }
  }

  rechazar() {
    if(this.inputText.length > 0){
    const sd_aprobacion_bp = this.summary_data;
    switch(this.origen) {
      case "bp":
        sd_aprobacion_bp["informacion_aprobacion"]["antecedentesBP"] = this.inputText;
        sd_aprobacion_bp.mensaje_historial="Líder CVB ha rechazado la solicitud"
        break;
      case "jefe_bp":
          sd_aprobacion_bp["informacion_aprobacion"]["antecedentesJefBP"] = this.inputText;
          sd_aprobacion_bp.mensaje_historial="BP ha rechazado la solicitud"
          break;
      case "gerente_personas":
        sd_aprobacion_bp["informacion_aprobacion"]["antecedentesGerPer"] = this.inputText;
        sd_aprobacion_bp.mensaje_historial="Gerente de Personas ha rechazado la solicitud"
        break;
    }
    this.requestFormService.putApplicationStatusUpdate(
      sd_aprobacion_bp,
      3,
      this.data["id_solicitud"],
      this.data["id_beneficio"]
    );
  }else{
    this.emptyFieldForm = true;
  }
}

}